/**
 * @generated SignedSource<<81db5e4df099982099bf718e1c0293a2>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type pantoneLibraryPageColorsQuery$variables = {
  after?: string | null;
  first?: number | null;
  id?: string | null;
  onlyDefaultColors?: boolean | null;
  orderBy?: string | null;
  paletteTypeID?: number | null;
  search?: string | null;
  useConversionTable?: boolean | null;
};
export type pantoneLibraryPageColorsQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"pantoneLibraryPage_colors">;
};
export type pantoneLibraryPageColorsQuery = {
  response: pantoneLibraryPageColorsQuery$data;
  variables: pantoneLibraryPageColorsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": "1",
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": 70,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "onlyDefaultColors"
  },
  {
    "defaultValue": "DESC",
    "kind": "LocalArgument",
    "name": "orderBy"
  },
  {
    "defaultValue": 1,
    "kind": "LocalArgument",
    "name": "paletteTypeID"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "search"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "useConversionTable"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "onlyDefaultColors",
    "variableName": "onlyDefaultColors"
  },
  {
    "kind": "Variable",
    "name": "orderBy",
    "variableName": "orderBy"
  },
  {
    "kind": "Variable",
    "name": "paletteTypeID",
    "variableName": "paletteTypeID"
  },
  {
    "kind": "Variable",
    "name": "search",
    "variableName": "search"
  },
  {
    "kind": "Variable",
    "name": "useConversionTable",
    "variableName": "useConversionTable"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "pantoneLibraryPageColorsQuery",
    "selections": [
      {
        "args": (v1/*:: as any*/),
        "kind": "FragmentSpread",
        "name": "pantoneLibraryPage_colors"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "pantoneLibraryPageColorsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "PaletteColorsConnection",
        "kind": "LinkedField",
        "name": "paletteColors",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PaletteColorsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PaletteColor",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "colorID",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "rgbHexCode",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cmykHexCode",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "spotColorName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "filters": [
          "search",
          "id",
          "paletteTypeID",
          "onlyDefaultColors",
          "orderBy",
          "useConversionTable"
        ],
        "handle": "connection",
        "key": "pantoneColorsQuery_paletteColors",
        "kind": "LinkedHandle",
        "name": "paletteColors"
      }
    ]
  },
  "params": {
    "cacheID": "795600a0f85306e853f382460fd5c313",
    "id": null,
    "metadata": {},
    "name": "pantoneLibraryPageColorsQuery",
    "operationKind": "query",
    "text": "query pantoneLibraryPageColorsQuery(\n  $after: String = \"1\"\n  $first: Int = 70\n  $id: String = null\n  $onlyDefaultColors: Boolean = null\n  $orderBy: String = \"DESC\"\n  $paletteTypeID: Int = 1\n  $search: String = null\n  $useConversionTable: Boolean = null\n) {\n  ...pantoneLibraryPage_colors_3e1OQA\n}\n\nfragment pantoneLibraryPage_colors_3e1OQA on Query {\n  paletteColors(first: $first, after: $after, search: $search, id: $id, paletteTypeID: $paletteTypeID, onlyDefaultColors: $onlyDefaultColors, orderBy: $orderBy, useConversionTable: $useConversionTable) {\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        colorID\n        name\n        rgbHexCode\n        cmykHexCode\n        spotColorName\n        __typename\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ab92584c06144feb1a9d087ea12d9473";

export default node;
